import { render, staticRenderFns } from "./ChatParticipants.vue?vue&type=template&id=a3287078&"
import script from "./ChatParticipants.vue?vue&type=script&lang=js&"
export * from "./ChatParticipants.vue?vue&type=script&lang=js&"
import style0 from "./ChatParticipants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports